import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Actions:
import { applyFiltersAction } from '../../../../../domain/state/mobile/actions';

// Selectors:
import { getHotelsCount } from '../../../../../domain/state/hotels/selectors';
import { isAwaitingFiltration } from '../../../../../domain/state/filters/status_selectors';

// Utils:
import { pluralize } from '../../../../../../../utils/stringUtils';

const className = 'lt-button';

function getButtonText(fetching, count) {
  if (fetching) {
    return 'Загрузка...';
  }
  return `${count ? `Показать ${count}` : 'Нет'} ${pluralize(count, [
    'отель',
    'отеля',
    'отелей',
  ])}`;
}

const mapStateToProps = (state) => ({
  hotelsCount: getHotelsCount(state),
  fetching: isAwaitingFiltration(state),
});

const mapDispatchToProps = (dispatch) => ({
  applyFilters: () => dispatch(applyFiltersAction()),
});

export const FiltersApplyMobile = connect(
  mapStateToProps,
  mapDispatchToProps,
)((props) => {
  const { fetching, hotelsCount, applyFilters, onClick } = props;

  const buttonText = getButtonText(fetching, hotelsCount);
  const disabled = fetching || !hotelsCount;
  const buttonClassName = classNames({
    [`${className} ${className}__big`]: true,
    [`${className}__white`]: !hotelsCount,
  });

  const handleClick = () => {
    applyFilters();
    onClick();
  };

  return (
    <div className="filters__submit">
      <StyledButton
        type="button"
        className={buttonClassName}
        onClick={handleClick}
        disabled={disabled}
      >
        {buttonText}
      </StyledButton>
    </div>
  );
});

FiltersApplyMobile.propTypes = {
  onClick: PropTypes.func,
  fetching: PropTypes.bool,
  applyFilters: PropTypes.func.isRequired,
  hotelsCount: PropTypes.number.isRequired,
};

FiltersApplyMobile.defaultProps = {
  fetching: false,
  onClick: Function.prototype,
};

const StyledButton = styled.button`
  position: fixed;
  bottom: 20px;
  margin: 0 20px;
  margin-top: 11px;
  padding: 12px 19px 14px;
  display: block;
  box-sizing: border-box;
  width: calc(100% - 40px);
  height: 42px;
  font-size: 15px;
  font-weight: bold;
  text-decoration: none;
  color: #000;
  background-color: #ffe700;
  border: 0;
  border-radius: 2px;
  box-shadow: 0 2px 0 0 #b27e01, inset 0 -11px 14px 0 #ffd100;
  user-select: none;
`;
